import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {useTranslation} from "@unibuddy/intl";
import PoweredByLogo from "../../../Experimental/General/components/PoweredByLogo/PoweredByLogo";
import s from "./PoweredByUnibuddy.pcss";
import VisuallyHidden from "../../../Experimental/A11y/components/VisuallyHidden/VisuallyHidden";

const PoweredByUnibuddy = ({redirectOnClick, className}) => {
    const {t} = useTranslation("common");

    if (redirectOnClick) {
        return (
            <React.Fragment>
                <a
                    className={classNames(s.container, className)}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.unibuddy.com"
                    aria-label={t("poweredByUnibuddy", "Powered By Unibuddy")}
                >
                    <PoweredByLogo title={t("poweredByUnibuddy", "Powered By Unibuddy")} />
                </a>
                <VisuallyHidden>{`, ${t(
                    "opensInANewWindow",
                    "Opens in a new window",
                )}`}</VisuallyHidden>
            </React.Fragment>
        );
    }

    return (
        <span className={classNames(s.container, className)}>
            <PoweredByLogo title={t("poweredByUnibuddy", "Powered By Unibuddy")} />
        </span>
    );
};

PoweredByUnibuddy.propTypes = {
    className: PropTypes.string,
    redirectOnClick: PropTypes.bool,
};

PoweredByUnibuddy.defaultProps = {
    className: "",
    redirectOnClick: true,
};

export default PoweredByUnibuddy;
